// src/pages/dashboards/PractitionerDashboard.jsx
// Practitioner portal: read-only access to linked clients' deductions.
// Nav: Clients (roster + per-client detail) and Connect Codes.

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { Users, Link2 } from "../../components/icons";

import PractitionerClients from "./practitioner/PractitionerClients";
import PractitionerClientDetail from "./practitioner/PractitionerClientDetail";
import PractitionerCodes from "./practitioner/PractitionerCodes";

const NAV = [
  { label: "Clients", path: "/practitioner", icon: Users },
  { label: "Connect Codes", path: "/practitioner/codes", icon: Link2 },
];

export default function PractitionerDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout nav={NAV} />}>
        <Route index element={<PractitionerClients />} />
        <Route path="client/:userId" element={<PractitionerClientDetail />} />
        <Route path="codes" element={<PractitionerCodes />} />
        <Route path="*" element={<Navigate to="/practitioner" replace />} />
      </Route>
    </Routes>
  );
}